import { render } from "./ActivityPage.vue?vue&type=template&id=5905cea6&scoped=true"
import script from "./ActivityPage.vue?vue&type=script&lang=js"
export * from "./ActivityPage.vue?vue&type=script&lang=js"

import "./ActivityPage.vue?vue&type=style&index=0&id=5905cea6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5905cea6"]])

export default __exports__